//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features/index';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsBvModerationEnabled = createHasFeatureSelector(
  FeatureNames.BvModeration,
);
